// components/HomeScreen.js
import React, { useEffect, useState } from 'react';
import { getSubjects, getYears, getSessions } from '../api';
import { useNavigate } from 'react-router-dom';

export default function HomeScreen({ 
  curriculum, setCurriculum,
  subject, setSubject,
  year, setYear,
  session, setSession,
  onSearch, papers
}) {
  const [subjects, setSubjects] = useState([]);
  const [years, setYears] = useState([]);
  const [sessions, setSessions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (curriculum) {
      getSubjects(curriculum).then(subjects => {
        const sortedSubjects = subjects.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        setSubjects(sortedSubjects);
      });
    }
  }, [curriculum]);

  useEffect(() => {
    if (curriculum && subject) {
      getYears(curriculum, subject).then(setYears);
    }
  }, [subject]);

  useEffect(() => {
    if (curriculum && subject && year) {
      getSessions(curriculum, subject, year).then(setSessions);
    }
  }, [year]);

  const getPaperNote = (paperName) => {
    const parts = paperName.replace('Paper ', '');
    if (parts === 'er') {
      return 'Examiners report';
    } else if (parts.toLowerCase() === 'gt') {
      return 'Grade threshold';
    } else if (/^\d+$/.test(parts) && parts.length >= 2) {
      const paperNum = parts[0];
      const compNum = parts[1];
      return (
        <>
          <span className="paper-note-blue">Paper {paperNum}</span> <span className="paper-note-green">Component {compNum}</span>
        </>
      );
    }
    return null;
  };

  const sortedPapers = papers.slice().sort((a, b) => {
    const parsePaper = (name) => {
      const parts = name.replace('Paper ', '');
      if (/^\d{2}$/.test(parts)) {
        return { main: parseInt(parts.charAt(0), 10), comp: parseInt(parts.charAt(1), 10) };
      }
      if (parts === 'ER') return { main: Infinity, comp: 0 };
      if (parts.toLowerCase() === 'gt') return { main: Infinity, comp: 1 };
      return { main: Infinity, comp: Infinity };
    };
    const aVal = parsePaper(a.name);
    const bVal = parsePaper(b.name);
    if (aVal.main === bVal.main) {
      return aVal.comp - bVal.comp;
    }
    return aVal.main - bVal.main;
  });

  return (
    <div className="home-screen">
      <div className="filters">
        <select value={curriculum} onChange={(e) => setCurriculum(e.target.value)}>
          <option value="">Select Curriculum</option>
          <option value="IGCSE">IGCSE</option>
          <option value="A-Levels">A-Levels</option>
        </select>

        <select value={subject} onChange={(e) => setSubject(e.target.value)}>
          <option value="">Select Subject</option>
          {subjects.map(subject => (
            <option key={subject} value={subject}>{subject}</option>
          ))}
        </select>

        <input
          type="number"
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value.replace(/\D/, ''))}
          min="1900"
          max="2099"
        />

        <select value={session} onChange={(e) => setSession(e.target.value)}>
          <option value="">Select Session</option>
          {sessions.map(session => (
            <option key={session} value={session}>{session}</option>
          ))}
        </select>

        <button onClick={onSearch}>Search</button>
      </div>

      <div className="paper-list">
        {sortedPapers.map(paper => (
          <div 
            key={paper.name}
            className="paper-item"
            onClick={() => navigate('/viewer', { state: { paper } })}
          >
            <div>{paper.name}</div>
            {getPaperNote(paper.name) && <div className="paper-note">{getPaperNote(paper.name)}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}